/**
 * Scrolls a message into view. No-op when the node is missing.
 * @param {HTMLElement | null | undefined} node
 */
export function scrollIntoViewSmooth(node) {
  if (!node || typeof node.scrollIntoView !== "function") {
    return;
  }
  try {
    node.scrollIntoView({ behavior: "smooth", block: "start" });
  } catch {
    /* Some environments expose scrollIntoView without the options form. */
  }
}
